export default {"src":"/_next/static/image/public/images/cross_icon.6ce22759f136c544f4f3df591bd5e8e0.svg","height":16,"width":16};